import { IUsersImportQuery } from '../interfaces/users-import.query.interface';

export class UsersImport {
    asyncJobId: string;

    constructor(query: IUsersImportQuery) {
        this.asyncJobId = query.async_job_id.toString();
    }
}
